export default __webpack_public_path__ + "e3be7aa2ba4c44624a20ee167d033c38.svg";